window.addEventListener('DOMContentLoaded', function () {
  let $highestPriorityFilter;
  jQuery(function ($) {
    /**
     * @type {MapRenderer}
     */
    let homepageMap = null;

    $('.camps-map__filter').on('click', function (e) {
      e.preventDefault();
      let location = $(this).data('location');

      if (!location) {
        console.error('No location found on filter element');
        return;
      }

      $('.camps-map__filter').removeClass('active');

      $(this).addClass('active');

      homepageMap.setFilters(
        {
          city: location,
        },
        {
          autocenter: true,
          fallback: {
            lng: $(this).data('lng'),
            lat: $(this).data('lat'),
          },
        },
      );
    });

    new Swiper(
      '.camps-map__filters.swiper:not(.swiper-initialized)',
      {
        slidesPerView: 'auto',
        spaceBetween: 0,
      },
    );

    $('.camps-map__search-cta').on('click', function () {
      let searchParams = new URLSearchParams();

      let inputs = $(this).closest('.camps-map__options-wrapper').find('input');

      inputs.get().forEach((input) => {
        searchParams.append(input.name, input.value);
      });

      window.location.href =
        window.theme.campFinder.searchDestination +
        '?' +
        searchParams.toString();
    });

    function selectTopFilter() {
      try {
        let $filtersWrapper = $('.camps-map__filters');

        if (!$filtersWrapper.length) throw 'No filters wrapper found';

        if (!$filtersWrapper.find('.swiper-slide[data-sort-priority]').length) {
          console.debug('No manual sorting required');
          return;
        }

        // Set highest priority tab as active
        $filtersWrapper.find('.swiper-slide').toggleClass('active', false);

        $highestPriorityFilter = $filtersWrapper.find(
          '.swiper-slide:first-of-type .camps-map__filter',
        );

        if (!$highestPriorityFilter.length)
          throw 'No highest priority filter found';

        let slidesToResort = $filtersWrapper.find(
          '.swiper-slide[data-sort-priority]',
        );

        if (!slidesToResort.length) throw 'No slides with priorities found';

        slidesToResort.each(function (idx, elem) {
          let $elem = $(elem);
          let thisPriority = parseInt($elem.attr('data-sort-priority'));
          let currentBestPriority = parseInt(
            $highestPriorityFilter.attr('data-sort-priority') ?? 0,
          );

          if (thisPriority > currentBestPriority) {
            $highestPriorityFilter = $elem;
          }
        });

        $highestPriorityFilter
          .find('.camps-map__filter')
          .toggleClass('active', true);

        let highestFilter = $highestPriorityFilter
          .find('.camps-map__filter')
          .data('location');

        let $highestPriorityCarousel = $(
          ".camps-map__city-definition[data-location='" + highestFilter + "']",
        );

        if (!$highestPriorityCarousel.length) throw 'No carousel found';

        $highestPriorityCarousel.toggleClass('active', true);
      } catch (e) {
        console.error(e);
      }
    }

    selectTopFilter();

    async function initMaps() {
      let highestPriorityCity = $('.camps-map__city-definition.active');
      const wrapper = document.querySelector('.homepage-map');

      // Don't re-initialize the map if it's already initialized
      if (homepageMap) homepageMap.getMap().remove();

      homepageMap = new MapRenderer({
        geojson: window.theme.campGeojsonData,
        container: wrapper,
        center: {
          lat: highestPriorityCity.data('lat'),
          lng: highestPriorityCity.data('lng'),
        },
        filters: {
          city: highestPriorityCity.data('location'),
        },
        zoom: 11,
      });
    }

    initMaps();
  });
});
